import { ManifestLoader } from './ManifestLoader';

export class JsonResourcesSetting {
	/**
	 * ID
	 */
	id: string;

	/**
	 * jsonファイルの所在
	 */
	srcJson?: string;

	/**
	 * 画像ファイルの所在
	 */
	srcImage: string;
}

export class JsonResources {
	/**
	 * リソース取得用クラス
	 */
	protected loader: createjs.ManifestLoader;

	/**
	 * スプライトシート
	 */
	protected ss: any = {};

	/**
	 * リソースの設定
	 */
    public settings:JsonResourcesSetting[];

	private static _instance: JsonResources;
	protected constructor() {
		const extendedClass = (<any>this).__proto__.constructor;
        extendedClass._instance = this;
	}

	public static singleton(): any {
		if (this._instance == null) {
			this._instance = new this();
		}
		return this._instance;
	}

	public static get instance(): JsonResources {
		return this.singleton();
	}

    protected setSetting( settings: JsonResourcesSetting[]){
        this.settings = settings;
    }

	protected async load(settings: JsonResourcesSetting[]): Promise<void> {
		// Manifestを作成
		let manifests = [];

		settings.forEach(setting => {
			if (setting.srcJson) {
				manifests.push({ id: setting.id + "Json", src: setting.srcJson });
			}
			manifests.push({ id: setting.id + "Image", src: setting.srcImage });
		})

		// リソース取得
		this.loader = <createjs.ManifestLoader>(
			await new ManifestLoader(manifests).load()
		);

		settings.forEach(setting => {
			const imageId = setting.id + "Image";
			const image: any = this.loader.getResult(imageId);
			if (setting.srcJson) {
				const jsonId = setting.id + "Json";
				const json: any = this.loader.getResult(jsonId);
				json.images = [this.loader.getResult(imageId)];
				this.ss[setting.id] = new createjs.SpriteSheet(json);
			} else {
				const bitmap = new createjs.Bitmap(this.loader.getResult(imageId));
				const bitmapWidth = bitmap.getBounds().width;
				const bitmaHeight = bitmap.getBounds().height;
				const data = {
					images: [this.loader.getResult(imageId)],
					frames: { width: bitmapWidth, height: bitmaHeight },
					animations: {}
				}
				data.animations[setting.id] = { "frames": [0] }
				this.ss[setting.id] = new createjs.SpriteSheet(data);
			}
		})
	}
}
